<div class="extensible">
  <div class="contract-actions mb-4">
    <button mat-flat-button color="accent" type="button" (click)="download_contract()">
      <mat-icon>download</mat-icon>
      Descargar contrato
    </button>

    @if (!its_me()) {
      <button mat-flat-button color="warn" type="button" (click)="open_finalize_contract_dialog()">
        <mat-icon>event_busy</mat-icon>
        Finalizar contrato
      </button>
    }
  </div>

  <form class="card" [formGroup]="form">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>Tipo de contrato</mat-label>
            <mat-select formControlName="working_contract_type_id">
              @for (working_contract_type of working_contract_types(); track working_contract_type) {
                <mat-option [value]="working_contract_type.id">{{ working_contract_type.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>Inicio contrato</mat-label>
            <input matInput [matDatepicker]="pickerStartDate" formControlName="start_date" />
            <mat-datepicker-toggle matIconSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerStartDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>Final contrato</mat-label>
            <input matInput [matDatepicker]="pickerEndDate" formControlName="end_date" />
            <mat-datepicker-toggle matIconSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerEndDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>Categoría departamento</mat-label>
            <mat-select formControlName="department_category_ids" multiple>
              @for (department_category of department_categories(); track department_category) {
                <mat-option [value]="department_category.id">{{ department_category.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <mat-form-field class="nobottom w-100" appearance="outline">
            <mat-label>Descripción de trabajo</mat-label>
            <textarea
              matInput
              formControlName="job_description"
              cdkTextareaAutosize
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="15"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>

  <app-working-contract-variable-condition-list
    [working_contract]="active_contract()"
    [working_contract_types]="working_contract_types()"
    [user]="user()"
    [its_me]="its_me()"
    [roles]="roles()"
    [department_categories]="department_categories()"
  />
</div>
